/** `.NET`-style `{0}` placeholders → i18next `{{0}}`. */
export const toI18nextTemplate = (value: string): string => value.replace(/\{(\d+)\}/g, '{{$1}}');

/** The SSR allow-list (`_LanguageSwitcher.cshtml`, `LocalizationController.cs`). */
export const SUPPORTED_CULTURES = ['en-GB', 'nb-NO'] as const;
export type Culture = (typeof SUPPORTED_CULTURES)[number];
export type Language = 'en' | 'nb';

export const isCulture = (value: unknown): value is Culture =>
  typeof value === 'string' && (SUPPORTED_CULTURES as readonly string[]).includes(value);

export const cultureToLanguage = (culture: Culture): Language =>
  culture === 'nb-NO' ? 'nb' : 'en';

/** Browser language → culture; Norwegian variants (nb, nn, no) map to nb-NO, everything else to en-GB. */
export const cultureFromNavigator = (navigatorLanguage: string | undefined): Culture => {
  const lower = (navigatorLanguage ?? '').toLowerCase();
  return lower.startsWith('nb') || lower.startsWith('nn') || lower.startsWith('no')
    ? 'nb-NO'
    : 'en-GB';
};
